import { useEffect, useState } from 'react';
import type { UserSessionData } from '@cencosud-cencommerce/paris-login';

interface UserSessionDataWithRegion extends UserSessionData {
  regionName?: string;
}

const DEFAULT_USER_DATA: UserSessionDataWithRegion = {
  email: '',
  firstName: ''
};

export const useStorageSession = () => {
  const [user, setUser] = useState<UserSessionData>(DEFAULT_USER_DATA);

  useEffect(() => {
    const storedSessionData = localStorage.getItem('sessionData');

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'sessionData' && event.newValue === null) {
        setUser(DEFAULT_USER_DATA);
      }
    };

    if (storedSessionData) {
      try {
        const parsedSessionData: UserSessionDataWithRegion =
          JSON.parse(storedSessionData);
        setUser(parsedSessionData);
      } catch (error) {
        setUser(DEFAULT_USER_DATA);
      }
    }

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const updateUserSession = (newUserData: UserSessionDataWithRegion) => {
    try {
      localStorage.setItem('sessionData', JSON.stringify(newUserData));
      setUser(newUserData);
    } catch (error) {
      console.error('Failed to update user session:', error);
    }
  };

  return { user, updateUserSession };
};
